import { render, staticRenderFns } from "./ButtonLoader.vue?vue&type=template&id=f5570fea&"
import script from "./ButtonLoader.vue?vue&type=script&lang=js&"
export * from "./ButtonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports